import React from 'react';
import styled from 'styled-components';
import { Switch, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../../theme/ThemeProvider';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  background: ${({ theme }) => theme.colors.chrome};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  transition: all 0.3s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }
`;

const IconWrapper = styled.span`
  color: ${({ $active, theme }) =>
    $active ? theme.colors.accent : theme.colors.textMuted};
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;

  ${({ theme }) => theme.mediaQuery.maxSm} {
    /* Decorative sun/moon flanking icons; this pill has no other responsive
       treatment and is one of the fixed-width contributors to the header row
       overflowing at phone widths — the header row's fixed-width floors sum
       to ~500px of chrome against a 375px viewport. Drop the icons and
       keep only the functional switch, mirroring how SelectorLabel/UserInfo
       already collapse at this breakpoint. */
    display: none;
  }
`;

const StyledSwitch = styled(Switch)`
  &.ant-switch {
    min-width: 36px;
  }
`;

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Tooltip title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
      <ToggleContainer>
        <IconWrapper $active={!isDarkMode}>
          <SunOutlined />
        </IconWrapper>
        <StyledSwitch
          checked={isDarkMode}
          onChange={toggleTheme}
          size="small"
        />
        <IconWrapper $active={isDarkMode}>
          <MoonOutlined />
        </IconWrapper>
      </ToggleContainer>
    </Tooltip>
  );
};

export default ThemeToggle;
